import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '~/context/GlobalContext';
import { IRoomProps } from '~/types/common';
import { UsersIcon } from '~/components/Icons/Icons';
import styles from '~/componentsPage/HomePage/styles/OnTopRoom.module.css';


const OnTopRoom = ({ data, goToChat }: IRoomProps) => {
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();

  return (
    <div data-component="OnTopRoom" className={styles.onTopRoom}>
      <div
        className={styles.roomButton}
        key={data.id}
        onClick={() => goToChat(data.id)}
      >
        <div className={styles.title}>
          {data.name}
        </div>
        <div className={styles.count}>
          <UsersIcon className={styles.usersIcon}/> 
          <div>{data.usersCount ? data.usersCount : '0'}</div>
        </div>
      </div>
    </div>
  );
};

export default OnTopRoom;
